import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
//import Button from "components/CustomButtons/Button.js";

import PropTypes from "prop-types";
import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import stylesCheckbox from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import axios from "axios";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import { Link } from "react-router-dom";
import * as Constants from "constants.js";

axios.defaults.withCredentials = true;

const stylesCard = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    textAlign: "left",
  },
};

const stylesSize = {
  size: {
    fontSize: "large",
    color: "black",
    opacity: 1,
    textAlign: "left",
  },
};

const stylesList = {
  list: {
    display: "inline",
    padding: "5px",
  },
};

const styleHeading = {
  heading: {
    fontWeight: "bold",
    textAlign: "center",
  },
};

const useStylesCheckbox = makeStyles(stylesCheckbox);
const useStylesAlert = makeStyles(stylesAlert);
const useStylesModal = makeStyles(stylesModal);

const useStylesCard = makeStyles(stylesCard);
const useStylesList = makeStyles(stylesList);
const useStylesHeading = makeStyles(styleHeading);
const useStylesSize = makeStyles(stylesSize);

export default function MyConferences(props) {
  const classesAlert = useStylesAlert();
  const classesCard = useStylesCard();
  const classesList = useStylesList();
  const classesCheckbox = useStylesCheckbox();
  const classesModal = useStylesModal();
  const classesHeading = useStylesHeading();
  const classesSize = useStylesSize();

  const classes = {
    ...classesAlert,
    ...classesModal,
    ...classesCard,
    ...classesList,
    ...classesCheckbox,
    ...classesHeading,
    ...classesSize,
  };

  const email = props.userInfo.email;

  const findEmailIndex = (item) => {
    return item.email == email;
  };

  const registrationEmailIndex = props.registrations.findIndex(findEmailIndex);

  const myRegistrations = props.registrations.filter((registration) => {
    return registration.email == email;
  });

  const getRegData = (conference) => {
    const filteredRegistration = myRegistrations.filter((registration) => {
      return registration.conference_name == conference;
    });

    if (filteredRegistration.length > 0) {
      return filteredRegistration[0];
    }
    return [];
  };

  //const symposiumData = getRegData("palicc_prevent_symposium_2022");
  const meetingData = getRegData(Constants.CURRENT_MEETING);

  //const symposiumLink =
  //   "https://usc.zoom.us/j/98762892163?pwd=TzgzQnlRWXl1VXNxT2laZDRnSHdkUT09";

  const preventMeetingLink =
    "https://usc.zoom.us/j/96674098889?pwd=TvbZj00Yz8z5TLTWOlevU059FZmBYQ.1";

  return (
    <div>
      {/* {symposiumData.conference_name && (
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card profile>
                <CardBody profile>
                  <div className={classes.size}>
                    <b>
                      <h3 className={classes.heading}>
                        Registered for Pediatric ARDS and Ventilator Liberation
                        Symposium
                      </h3>
                    </b>
                    <div>
                      <h4 className={classes.heading}>Registration Number</h4>

                      <h5 className={classes.center}>
                        {symposiumData.confirmation_code}
                      </h5>
                      <h4 className={classes.heading}>Dates</h4>

                      <h5 className={classes.center}>
                        March 31-April 1, 2022, concluding mid-day April 1, 2022
                      </h5>

                      <h4 className={classes.heading}>Location</h4>

                      <h5 className={classes.center}>
                        Loews Coronado Bay Resort, San Diego, CA
                      </h5>

                      <h4 className={classes.heading}>Registration Type</h4>

                      <h5 className={classes.center}>
                        {symposiumData.registration_type}
                      </h5>

                      <h4 className={classes.heading}>Conference Link</h4>

                      <h5 className={classes.center}>
                        {" "}
                        <a
                          href={symposiumLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {symposiumLink}
                        </a>
                      </h5>

                      <br></br>
                      <div className={classes.center}>
                        <Link
                          to="/files/SymposiumPrelimAgenda.pdf"
                          target="_blank"
                          download
                        >
                          <Button
                            style={{ fontSize: "large" }}
                            color="info"
                            className={classes.updateProfileButton}
                          >
                            Download Agenda
                          </Button>
                        </Link>
                        <br></br>

                        <Link
                          to="/files/PARDS Protocol Template_29MAR2022_clean.docx"
                          target="_blank"
                          download
                        >
                          <Button
                            style={{ fontSize: "large" }}
                            color="info"
                            className={classes.updateProfileButton}
                          >
                            Download Master Protocol Draft
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      )} */}
      {meetingData.conference_name && (
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card profile>
                <CardBody profile>
                  <div className={classes.size}>
                    <b>
                      <h3 className={classes.heading}>PREVENT Fall Meeting 2024</h3>
                    </b>
                    <div>
                      <h4 className={classes.heading}>Registration Number</h4>

                      <h5 className={classes.center}>
                        {meetingData.confirmation_code}
                      </h5>
                      <h4 className={classes.heading}>Dates</h4>

                      <h5 className={classes.center}>
                      Sep 5, 2024 03:45 PM Central Time (US and Canada)
                      </h5>

                      <h4 className={classes.heading}>Location</h4>

                      <h5 className={classes.center}>Virtual Meeting</h5>

                      <h4 className={classes.heading}>Registration Type</h4>

                      <h5 className={classes.center}>
                        {meetingData.registration_type}
                      </h5>

                      {meetingData.agenda_topic && (
                        <div>
                          <h4 className={classes.heading}>
                            Agenda Request Topic
                          </h4>

                          <h5 className={classes.center}>
                            {meetingData.agenda_topic}
                          </h5>

                          <h4 className={classes.heading}>Requested Time</h4>

                          <h5 className={classes.center}>
                            {meetingData.agenda_time} minutes
                          </h5>
                        </div>
                      )}

                      <h4 className={classes.heading}>Conference Link</h4>

                      <h5 className={classes.center}>
                        {" "}
                        <a
                          href={preventMeetingLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {preventMeetingLink}
                        </a>
                      </h5>

                      <br></br>
                      {/* <div className={classes.center}>
                        <Link
                          to="/files/PreventMeetingAgenda.pdf"
                          target="_blank"
                          download
                        >
                          <Button
                            style={{ fontSize: "large" }}
                            color="info"
                            className={classes.updateProfileButton}
                          >
                            Download Agenda
                          </Button>
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      )}
      {registrationEmailIndex == -1 && (
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card profile>
                <CardBody profile>
                  <div className={classes.size}>
                    <b>
                      <h3 className={classes.heading}>
                        You are not registered for any conferences/meetings.
                      </h3>
                      <Link to="/portal/conferences">
                        Click Here to Register!
                      </Link>
                    </b>
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      )}
    </div>
  );
}

MyConferences.propTypes = {
  userInfo: PropTypes.Object,
  registrations: PropTypes.Object,
  users: PropTypes.Object,
  reloadRegistrationsCallBack: PropTypes.func,
};
